/**
 * Maps old screen(tpl files) names to component router paths used to replace them
 */
export const phpScreenToComponentUrl: { [key: string]: string } = {
    'ekran_obiektow.php': '/lista',
    'ekran_kalendarza_osobistego.php': '/kalendarz'
};
